/* global jQuery, elementorFrontend, bpd_widget_vars, ScrollMagic, tingle, MicroModal, Typed */
( function( $ ) {
	jQuery( window ).on( 'elementor/frontend/init', () => {

		/**
		* BPD Expand Card
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdExpandCardHandler = ( $element, $ ) => {
			$element.on('click', function(e){
				let $this = $element.find('.bpd-expandcard');
				$this.addClass('open');
				setTimeout(function(){
					$('.bpd-expandcard').not($this).removeClass('open');
				}, 400);
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-expandcard.default', bpdExpandCardHandler );


		/**
		* BPD Heading Typer
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdHeadingTyperHandler = ( $element, $ ) => {
			let elementId = $element.data('id');
			let typedContainer = $element.find('.headingtyper__typed');
			let typedEntries = $element.find('.headingtyper-entry');
			
			let typedEntriesArray = [];
			typedEntries.each(function(){
				typedEntriesArray.push($(this)[0].innerText);
			});

			let typed = new Typed(typedContainer[0], {
				backDelay: 2500,
				backSpeed: 30,
				loop: true,
				smartBackspace: false,
				startDelay: 800,
				strings: typedEntriesArray,
				typeSpeed: 50,
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-headingtyper.default', bpdHeadingTyperHandler );

		/**
		* BPD Nested Accordion
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdNestedAccordionHandler = ( $element, $ ) => {
			console.log( 'loaded' );
			console.log( $element );

			if( ! $('body').hasClass('elementor-editor-active') ) {
				$element.find('.e-n-accordion-item').each(function(){
					let $this = $(this);
					// e-n-accordion-item-title

					if ( ! $this.find('.elementor-element').children().length > 0 ) {
						$this.css('pointerEvents', 'none');
						$this.find('.e-n-accordion-item-title-icon').css('display', 'none');
					}
				});
			}
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/nested-accordion.default', bpdNestedAccordionHandler );

		/**
		* BPD Countup
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdCountHandler = ( $element, $ ) => {
			let controller = new ScrollMagic.Controller({
				globalSceneOptions: {
					duration: 0,
					triggerHook: .75
				}
			});

			$element.find('.counter').each(function() {
				let $this = $(this);
				let countTo = $this.attr('data-count');

				// build scenes
				new ScrollMagic.Scene({triggerElement: $this[0]})
					.reverse(false)
					// .addIndicators()
					.on("enter", function (e) {
						$({ countNum: $this.text()}).animate({
							countNum: countTo
						}, {
							duration: 1500,
							easing: 'linear',
							step: function() {
								$this.text(Math.floor(this.countNum));
							},
							complete: function() {
								$this.text(this.countNum);
							}
						});
					})
					.addTo(controller);
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-count.default', bpdCountHandler );


		/**
		* BPD Featured Speakres
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdSpeakersHandler = ( $element, $ ) => {
			/*--------------------------------------------------------------------------------
			Modals
			--------------------------------------------------------------------------------*/

			MicroModal.init({
				awaitOpenAnimation: true,
				awaitCloseAnimation: false,
				disableFocus: true,
				disableScroll: true
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-featuredspeakers.default', bpdSpeakersHandler );


		/**
		* BPD Prediction
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const bpdPredictionHandler = ( $element, $ ) => {
			let elementId = $element.data('id');

			let controller = new ScrollMagic.Controller({
				globalSceneOptions: {
					duration: 0,
					triggerHook: .7
				}
			});

			$element.find('.bpd-prediction').each(function() {
				let $this = $(this);

				// build scenes
				new ScrollMagic.Scene({triggerElement: $this[0]})
					.setClassToggle($this[0], "active")
					.reverse(false)
					// .addIndicators()
					.addTo(controller);
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-prediction.default', bpdPredictionHandler );


		/**
		* BPD Staff Search
		*
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		let staffSearchLoad = false;
		const bpdStaffSearchHandler = ( $element, $ ) => {
			let elementId = $element.data('id');

			let modal_id = 'staffsearch_modal_' + elementId;
			window[modal_id] = new tingle.modal({
				footer: false,
				closeMethods: ['overlay', 'button', 'escape'],
				closeLabel: "Close",
				cssClass: ['modal-staffsearch'],
				onOpen: function() {
					// console.log(window[modal_id]);
					// window.dispatchEvent(new Event('resize'));
					window[modal_id].checkOverflow();
					window[modal_id]._events.resize();

					setTimeout(() => {
						window[modal_id].checkOverflow();
						// staffsearch_modal._events.resize();
					}, 200);
				},
				onClose: function() {
					window[modal_id].setContent('');
				},
				beforeOpen: function() {
				}
			});

			// Check URL for modal to display on load
			if( window.location.hash && ! staffSearchLoad ) {
				staffSearchLoad = true;

				let slug = window.location.hash.replace('#','');
				
				let data = {
					action: 'bpd_ajax_modal',
					slug: slug
				};

				$.ajax({
					type: 'POST',
					url: bpd_widget_vars.ajaxurl,
					data: data,
					success: function(response) {
						window[modal_id].setContent(response);
						window[modal_id].open();
					},
					error: function(error) {
						console.log('ajax error');
						console.log(error);
					}
				});
			}

			// Handle modal generation on staff member click
			$(document).on( 'click', '.elementor-widget-bpd-staffsearch[data-id=' + elementId + '] .bpd-view-staffcard', function(e) {
				e.preventDefault();
				let post_id = $(this).data('postid');
				let post_slug = $(this).data('slug');

				window.location.hash = post_slug;
				
				if( typeof post_id === 'number' ) {
					let data = {
						action: 'bpd_ajax_modal',
						post_id: post_id
					};

					$.ajax({
						type: 'POST',
						url: bpd_widget_vars.ajaxurl,
						data: data,
						success: function(response) {
							window[modal_id].setContent(response);
							window[modal_id].open();
						},
						error: function(error) {
							console.log('ajax error');
							console.log(error);
						}
					});
				} else {
					console.log('Error: Post ID not found.')
				}
			});

			// Manage search form submissions
			$(document).on('submit', '#live-search-form', function(e) {
				e.preventDefault();
				submitLiveSearch( $(this) );
			});

			$(document).on('change', '#live-search-form input[type="radio"]', function(e) {
				e.preventDefault();
				submitLiveSearch( $('#live-search-form') );
			});

			submitLiveSearch( $('#live-search-form') );
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bpd-staffsearch.default', bpdStaffSearchHandler );


		/*--------------------------------------------------------------------------------
		Manage live search functionality
		--------------------------------------------------------------------------------*/

		/**
		* Search setup and defaults
		**/

		let doAction = false,
		ajaxActive = false,
		firstSearch = true,
		emptyFirst = false;

		let form_data = [];
		const search_options = {
			empty_search: false,
			pagination: 'loadmore',
			page: 1,
			page_type: 'standard',
			page_type_id: false,
			per_page: 12,
			post_type: 'post',
			tax_query: 'AND',
			template: 'card'
		};

		// Fetch current URL and any pre-search parameters
		const url = new URL(window.location);
		const params = new URLSearchParams(url.search);

		// Submit form on page ready for initial results
		$( document ).ready(function() {
			let form = $('#live-search-form');

			emptyFirst = form.data('emptyfirst');

			if( form.length ) {
				params.forEach((value, key) => {
					// Check for general filters in URL
					let fields = $(this).find('input:radio[name=' + key + ']');
					if( fields.length !== 0 ) {
						let currentField = fields.filter('[value=' + value + ']');
						currentField.prop('checked', true);

						$('#live-search-viewall').addClass('active');
					}
				});

				// Check for search terms in URL
				let search = params.get('search');
				if ( search ) {
					$('#live-search').val(search);
				}

				// Initial form submit
				form.submit();
				firstSearch = false;
			}
		});


		/**
		* Utility Functions
		**/

		function getNestedValue( obj, ...args ) {
			return args.reduce((obj, level) => obj && obj[level], obj)
		}


		/**
		* Handle form submission
		**/

		// Capture search form submissions
		$( document ).on( 'submit', '#live-search-form', function(e) {
			e.preventDefault();
			let $this = $(this);

			// Disable submit button
			if( ! firstSearch ) $this.find('.search-submit').attr('disabled', true);

			// Start search process
			submitLiveSearch($this);
		});

		// Begin live search process
		function submitLiveSearch( $this ) {
			// Setup form options
			if( $this.data('pagination') ) search_options.pagination = $this.data('pagination');
			if( $this.data('perpage') ) search_options.per_page = $this.data('perpage');
			if( $this.data('searchtype') ) search_options.post_type = $this.data('searchtype');
			if( $this.data('tax_query') ) search_options.tax_query = $this.data('tax_query');
			if( $this.data('template') ) search_options.template = $this.data('template');
			if( $this.data('page_type') ) search_options.page_type = $this.data('page_type');
			if( $this.data('page_type_id') ) search_options.page_type_id = $this.data('page_type_id');

			form_data = $this.serializeArray();

			// Reset timeout for new search if necessary
			if( doAction ) { clearTimeout( doAction ); }

			// Execute search, prevent stacked searches with timeout		
			if( firstSearch && emptyFirst ) {
				//
			} else {
				doAction = setTimeout( function() {
					_do_live_search();
				}, 250 );
			}
		}


		/**
		* Handle live search functionality
		**/

		// Execute search
		function _do_live_search() {
			// Exit if AJAX is currently running
			if ( ajaxActive ) return false;

			$('.live-search-container').addClass('processing');

			// Run AJAX search
			ajaxActive = true;

			// Run AJAX
			$.when( _ajax_live_search() ).done(function( response ) {
				// console.log( response );

				// Handle post-search cleanup & display
				_do_after_search( response );
			});
		}

		// Process AJAX
		function _ajax_live_search() {
			let data = {
				action: 'ajax_search',
				form_data: form_data,
				nonce: bpd_widget_vars.nonce,
				search_options: search_options
			};

			return $.ajax({
				type: 'POST',
				url: bpd_widget_vars.ajaxurl,
				data: data,
				success: function(response) {
					// console.log(response);
					ajaxActive = false;
				},
				error: function(error) {
					console.log(error);
					console.log('error');
					ajaxActive = false;
				}
			});
		}

		// Handle results after search
		function _do_after_search( response ) {
			$('.live-search-container').removeClass('processing');

			_build_results( response );
			doAction = false;
		}

		// Display results
		function _build_results( response ) {
			let template = response.template;
			let post_type = response.post_type;
			let numberposts = response.numberposts;

			if ( numberposts > 0 ) {
				let page = getNestedValue(response, 'pagination', 'page');
				let pagination_type = getNestedValue(response, 'pagination', 'type');
				_destroy( page );
				// $('#live-search-count').text('Results: ' + response.numberposts);

				if( pagination_type == 'loadmore' ) {
					// Append results
					$('#live-search-results').append( response.results );

					// Setup load more button
					let more_pagination = getNestedValue(response, 'pagination', 'more');
					if( more_pagination === false ) {
						$('#live-search-loadmore').html('');
					} else {
						$('#live-search-loadmore').html('<a id="loadmore" href="#" data-page="' + (page + 1) + '">See More</a>');
					}
				}
			}
			// No results
			else {
				_destroy();
				$('#live-search-count').text('Results: 0');
				$('#live-search-results').append('<p class="noresults">No results found.</p>');
				$('#live-search-loadmore').html('');
			}
		}

		// Destroy search results and/or button
		function _destroy( page = 1, style = 'standard' ) {
			if( page !== 1 ) {
				$('#loadmore').remove();
			} else {
				$('#live-search-results').empty();
			}
		}


		/**
		* Handle form interactivity
		**/

		$(document).on('click', '#live-search-viewall', function(e) {
			e.preventDefault();
			$('#live-search-viewall').removeClass('active');

			$('#live-search-form').trigger('reset');
			$('#live-search-form').submit();
		});

		// Handle radio changes
		$(document).on('change', '#live-search-form input[type="radio"]', function(e) {
			e.preventDefault();
			search_options.page = 1;
			$('#live-search-viewall').addClass('active');
			$('#live-search-form').submit();
		});


		// Handle load more button
		$( document ).on( 'click', '#loadmore', function(e) {
			e.preventDefault();
			let $this = $(this);

			search_options.page = $this.data('page');

			if ( doAction ) { clearTimeout( doAction ); }

			doAction = setTimeout( function() {
				_do_live_search();
			}, 250 );
		});

		// Handle pagination clicks
		$( document ).on( 'click', '.loadmore .loadmore-page', function(e) {
			e.preventDefault();
			let $this = $(this);

			if( $this.hasClass('enabled') ) {
				search_options.page = $this.data('page');
				if ( doAction ) { clearTimeout( doAction ); }
				doAction = setTimeout( function() {
					_do_live_search();
				}, 250 );
			}
		});



	} );
} )( jQuery );
